import React from "react";
import Footer from "components/footer/Footer";
import SignUpForm from "components/auth/SignUpForm";

import SectionImage from "assets/images/section-bg.svg";
import GirlWithDog from "../../assets/images/homeImage.png";

const SignUp = () => {
  return (
    <div className="w-full tw-h-full">
      {/* //1st main div */}
      <div className="tw-w-full tw-flex">
        <div className="tw-w-full lg:tw-w-[50%] tw-flex tw-flex-col tw-relative tw-bg-[#EFEFEF] lg:tw-rounded-r-[30px]">
          <div
            className="tw-w-full tw-h-screen lg:tw-h-full lg:tw-absolute tw-inset-0 tw-bg-[ #EFEFEF] tw-z-10"
            style={{ mixBlendMode: "luminosity" }}
          >
            <img
              src={SectionImage}
              className="tw-h-full tw-w-full tw-object-cover"
              alt="section"
            />
          </div>
          <div className="tw-w-full tw-absolute tw-mx-auto tw-top-[100px] tw-z-20">
            <SignUpForm />
          </div>
        </div>

        <div className="tw-hidden lg:tw-flex lg:tw-w-[55%] tw:w-h-full lg:tw-ml-[-2rem]">
          <div className="lg:tw-w-full lg:tw-h-full">
            <img
              src={GirlWithDog}
              className="tw-w-full tw-h-full"
              alt="girl with dog"
            />
          </div>
        </div>
      </div>
      {/* //2nd main div */}
      <div className="tw-flex tw-w-full">
        <Footer />
      </div>
    </div>
  );
};

export default SignUp;
